module.exports = __webpack_public_path__ + "img/12.bf43f673.png";